// @ts-ignore
import React, { HTMLAttributes } from "react";

import { css } from "@compiled/react";

export type PriceAltContainerProps = HTMLAttributes<HTMLDivElement>;

export const PriceAltContainer = (props: PriceAltContainerProps) => {
    return (
        <div css={priceAltTextCss} {...props}>
            {props.children}
        </div>
    );
};

const priceAltTextCss = css({
    fontSize: "14px",
    textAlign: "center"
});
